import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
    IroNamRequestStatus,
    OmEmeaRequestStatus,
    OmNamRequestStatus,
    RequestState
} from '@shs-digi-care-monorepo/interfaces';
import { statusColorMap } from './config/status-color-map.config';

@Component({
    selector: 'app-requests-status-pill',
    templateUrl: './requests-status-pill.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RequestsStatusPillComponent {
    public status: InputSignal<RequestState | OmEmeaRequestStatus | OmNamRequestStatus | IroNamRequestStatus> =
        input.required<RequestState | OmEmeaRequestStatus | OmNamRequestStatus | IroNamRequestStatus>();
    public isOnHold: InputSignal<boolean> = input<boolean>(false);
    public size: InputSignal<'sm' | 'md' | 'lg'> = input<'sm' | 'md' | 'lg'>('md');

    protected statusColorMap = statusColorMap;

    protected sizeMap: Record<string, string> = {
        sm: 'text-xs px-2 py-1 rounded-sm',
        md: 'text-sm px-3 py-1 rounded-md',
        lg: 'text-base px-4 py-2 rounded-md'
    };
}
